const Menu =  [
    { header: 'Guest' },
    {
        path    : '/',
        title   : 'Welcome',    
        name    : 'welcome',           
        meta    : {public:true, guest:true}
    },                              
    //{title: 'Welcome', name: 'welcome', meta:{public:true, guest:true}},
    {title: 'Login', name: 'login', meta:{public:true, guest:true}},
    {title: 'Register', name: 'register', meta:{public:true, guest:true}},    
    //NON MENU
    { group: 'dashboard',
      visible: false,
      items:[
        { title : 'Home', meta:{guest:false}},        
        { title : 'Profile', name: 'profile', meta:{guest:false}},
        { title : 'Update Profile', name: 'profile/form', meta:{guest:false}},
      ]
    },
    { title : 'Ujian', name: 'ujian', visible: false, meta:{guest:false}},    
];

import Remenu from '@/util/remenu';
export default Remenu(Menu);
